(function(angular) {
  'use strict';

  angular.module('onvio.setup')
      .controller('onvio.setup.models.AddCostsCalculationController', modelAddCostsCalculationController);

  modelAddCostsCalculationController.$inject = ['$state'];

  function modelAddCostsCalculationController($state) {
    /*jshint validthis:true */
    var vm = this;
    vm.templateId = $state.params.templateId;

    vm.navigateTo = function(event) {
        $state.go(event.path, event.data);
    };
  }
})(window.angular);
